import { createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import i18n from 'i18next';

import { apiReducerBuilder } from 'utils';

import { UserSettings } from 'models';

import {
	changePassword,
	deleteAccountConfirm,
	deleteAccountRequest,
	downloadUserAgreement,
	getUserSettings,
	notifications,
	updateUserSettings,
	uploadTaxDocuments,
} from './actions';
import { logout } from '../authorization/actions';

interface userSettingsState {
	status: string;
	entity: UserSettings;
}

const userSettingsSlice = createSlice({
	name: 'userSettings',
	initialState: {
		entity: {},
	} as userSettingsState,
	reducers: {},
	extraReducers: (builder) => {
		apiReducerBuilder(builder, getUserSettings, (state, action) => {
			const { payload, meta } = action;
			state.status = meta.requestStatus;
			state.entity = payload;
		});
		apiReducerBuilder(builder, uploadTaxDocuments, (state, action) => {
			const { payload, meta } = action;

			state.status = meta.requestStatus;
			state.entity = payload;

			message.success(i18n.t('documentsSentText') as string);
		});

		apiReducerBuilder(builder, downloadUserAgreement, (state, action) => {
			const { meta } = action;
			state.status = meta.requestStatus;
		});

		apiReducerBuilder(builder, notifications, (state, action) => {
			const { meta, payload } = action;

			state.status = meta.requestStatus;
			state.entity = payload;
		});

		apiReducerBuilder(builder, updateUserSettings, (state, action) => {
			const { meta, payload } = action;

			state.status = meta.requestStatus;
			state.entity = { ...state.entity, ...payload };
			message.success(i18n.t('yourChangesSavedText') as string);
		});

		apiReducerBuilder(builder, changePassword, (state, action) => {
			const { meta } = action;

			state.status = meta.requestStatus;

			message.success(i18n.t('yourPasswordUpdateText') as string);
		});

		apiReducerBuilder(builder, deleteAccountConfirm, (state, action) => {
			const { meta } = action;
			state.status = meta.requestStatus;
			state.entity = {};
		});

		builder
			.addCase(deleteAccountRequest.pending, (state, action) => {
				const { meta }: { [key: string]: any } = action;
				state.status = meta.requestStatus;
			})
			.addCase(deleteAccountRequest.fulfilled, (state, action) => {
				const { meta } = action;
				state.status = meta.requestStatus;
				message.success('Your request for account deletion was successfully sent');
			})
			.addCase(deleteAccountRequest.rejected, (state, action) => {
				const { meta } = action;
				state.status = meta.requestStatus;
				message.warn('The investor already has an active removal request.');
			});

		builder.addCase(logout, (state) => {
			state.status = '';
			state.entity = {} as UserSettings;
		});
	},
});

export default userSettingsSlice.reducer;
